import { render, staticRenderFns } from "./formFiltroDocumentos.vue?vue&type=template&id=42b75fff&scoped=true&"
import script from "./formFiltroDocumentos.vue?vue&type=script&lang=js&"
export * from "./formFiltroDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./formFiltroDocumentos.vue?vue&type=style&index=0&id=42b75fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b75fff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCheckbox,VContainer,VDatePicker,VDialog,VExpansionPanel,VExpansionPanelContent,VFlex,VForm,VLayout,VSpacer,VTextField})
